import { render, staticRenderFns } from "./accounts-audit.vue?vue&type=template&id=c53e7240&scoped=true"
import script from "./accounts-audit.vue?vue&type=script&lang=js"
export * from "./accounts-audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e7240",
  null
  
)

export default component.exports